var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountSettingsPopupUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 238,
    viewBox: "0 0 238 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M118.781 237.278C184.227 237.278 237.281 184.224 237.281 118.778C237.281 53.3326 184.227 0.27832 118.781 0.27832C53.3355 0.27832 0.28125 53.3326 0.28125 118.778C0.28125 184.224 53.3355 237.278 118.781 237.278Z",
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19412_78877",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 238,
    height: 238
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M118.781 237.278C184.227 237.278 237.281 184.224 237.281 118.778C237.281 53.3326 184.227 0.27832 118.781 0.27832C53.3355 0.27832 0.28125 53.3326 0.28125 118.778C0.28125 184.224 53.3355 237.278 118.781 237.278Z",
    fill: "#F8F8F8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19412_78877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Scratch icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M190.873 227.956H64.1953V71.8261C64.1953 66.7961 68.2326 62.7588 73.2626 62.7588H181.806C186.836 62.7588 190.873 66.7961 190.873 71.8261V227.956Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M182.6 62.7588H72.4684C67.9017 62.7588 64.1953 66.4651 64.1953 71.0319V79.7021H190.873V71.0319C190.873 66.4651 187.167 62.7588 182.6 62.7588Z",
    fill: "#F3D1CB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M79.348 72.2248C79.348 73.3499 78.4215 74.2103 77.3625 74.2103C76.3035 74.2103 75.377 73.2838 75.377 72.2248C75.377 71.0997 76.3035 70.2393 77.3625 70.2393C78.4215 70.2393 79.348 71.0997 79.348 72.2248Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M87.3617 72.2248C87.3617 73.3499 86.4351 74.2103 85.3762 74.2103C84.251 74.2103 83.3906 73.2838 83.3906 72.2248C83.3906 71.0997 84.3172 70.2393 85.3762 70.2393C86.5013 70.2393 87.3617 71.0997 87.3617 72.2248Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M95.4359 72.2248C95.4359 73.3499 94.5093 74.2103 93.4504 74.2103C92.3252 74.2103 91.4648 73.2838 91.4648 72.2248C91.4648 71.0997 92.3914 70.2393 93.4504 70.2393C94.5755 70.2393 95.4359 71.0997 95.4359 72.2248Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M160.432 156.149H92.5928C83.3932 156.149 75.9805 148.67 75.9805 139.536V107.503C75.9805 98.3033 83.4593 90.8906 92.5928 90.8906H160.432C169.632 90.8906 177.045 98.3695 177.045 107.503V139.536C177.045 148.736 169.632 156.149 160.432 156.149Z",
    fill: "#F6EFE8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M164.599 80.5633L64.1972 80.2323C63.8663 80.2323 63.6016 79.9676 63.6016 79.6367C63.6016 79.3058 63.8663 79.041 64.1972 79.041L164.599 79.3719C164.93 79.3719 165.195 79.6367 165.195 79.9676C165.195 80.2985 164.93 80.5633 164.599 80.5633Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M190.875 228.553C190.544 228.553 190.279 228.289 190.279 227.958V71.2323C190.279 66.9303 186.771 63.3564 182.403 63.3564H72.6689C68.3669 63.3564 64.7929 66.8642 64.7929 71.2323V227.958C64.7929 228.289 64.5281 228.553 64.1972 228.553C63.8663 228.553 63.6016 228.289 63.6016 227.958V71.2323C63.6016 66.2023 67.705 62.165 72.6689 62.165H182.469C187.499 62.165 191.537 66.2685 191.537 71.2323V227.958C191.47 228.289 191.206 228.553 190.875 228.553Z",
    fill: "#4A154B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M155.332 98.5669H83.5879V90.9557C83.5879 86.8522 86.8971 83.543 91.0006 83.543H155.398C159.502 83.543 162.811 86.8522 162.811 90.9557V91.1542C162.745 95.2577 159.436 98.5669 155.332 98.5669Z",
    fill: "#F3D1CB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M157.384 87.7139H89.9414V89.9641H157.384V87.7139Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M123.696 92.542H89.9414V94.7923H123.696V92.542Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M161.236 140.923H138.317C134.799 140.923 131.906 138.03 131.906 134.513V111.594C131.906 108.077 134.799 105.184 138.317 105.184H161.236C164.753 105.184 167.646 108.077 167.646 111.594V134.513C167.646 138.087 164.753 140.923 161.236 140.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1738",
    d: "M134.703 124.283H138.668V141.465H134.703V124.283Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1739",
    d: "M141.311 113.71H145.276V141.465H141.311V113.71Z",
    fill: "#F3D1CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1740",
    d: "M147.92 122.962H151.885V141.465H147.92V122.962Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1741",
    d: "M154.527 136.179H158.492V141.465H154.527V136.179Z",
    fill: "#EFEFEF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M104.955 116.768C104.955 117.362 105.451 117.759 105.946 117.759C106.541 117.759 106.938 117.263 106.938 116.768C106.938 116.272 106.442 115.776 105.946 115.776C105.451 115.776 104.955 116.173 104.955 116.768Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M101.285 119.374C101.663 119.752 102.324 119.752 102.701 119.374C103.079 118.996 103.079 118.336 102.701 117.958C102.324 117.58 101.663 117.58 101.285 117.958C100.907 118.43 100.907 118.996 101.285 119.374Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M99.4604 124.374C100.051 124.374 100.445 123.878 100.445 123.383C100.445 122.788 99.9528 122.392 99.4604 122.392C98.8694 122.392 98.4754 122.887 98.4754 123.383C98.3769 123.878 98.8694 124.374 99.4604 124.374Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M102.082 128.657C102.46 128.28 102.46 127.619 102.082 127.241C101.704 126.864 101.044 126.864 100.666 127.241C100.288 127.619 100.288 128.28 100.666 128.657C101.138 129.035 101.704 129.035 102.082 128.657Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M107.006 129.869C107.006 129.274 106.51 128.878 106.015 128.878C105.42 128.878 105.023 129.374 105.023 129.869C105.023 130.464 105.519 130.86 106.015 130.86C106.609 130.86 107.006 130.464 107.006 129.869Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M111.354 127.177C110.976 126.799 110.315 126.799 109.937 127.177C109.56 127.554 109.56 128.215 109.937 128.593C110.315 128.97 110.976 128.97 111.354 128.593C111.731 128.215 111.731 127.554 111.354 127.177Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M109.937 117.91C109.56 118.288 109.56 118.949 109.937 119.326C110.315 119.704 110.976 119.704 111.354 119.326C111.731 118.949 111.731 118.288 111.354 117.91C110.881 117.533 110.315 117.533 109.937 117.91Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M112.233 123.983H124.147C124.477 123.983 124.742 123.719 124.742 123.388C124.742 123.057 124.477 122.792 124.147 122.792H112.233C111.902 122.792 111.638 123.057 111.638 123.388C111.571 123.652 111.836 123.983 112.233 123.983Z",
    fill: "#4A154B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M121.836 186.129L134.743 201.55C135.272 202.212 136.199 202.278 136.86 201.815C140.103 199.498 148.84 191.093 155.789 165.479L171.74 170.84C166.313 212.735 150.031 225.906 150.031 225.906L122.366 226.105L104.496 203.337L121.836 186.129Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M122.104 226.769L103.705 203.274L121.906 185.271L135.275 201.156C135.606 201.553 136.202 201.619 136.599 201.288C139.908 198.905 148.446 190.566 155.263 165.284C155.329 164.953 155.66 164.754 155.991 164.82C156.322 164.886 156.521 165.217 156.454 165.548C149.505 191.162 140.769 199.7 137.327 202.215C136.4 202.877 135.077 202.744 134.349 201.818L121.84 186.926L105.294 203.406L122.634 225.512L149.77 225.313C151.424 223.791 166.051 209.694 171.081 170.777C171.147 170.446 171.412 170.181 171.743 170.247C172.074 170.314 172.339 170.578 172.272 170.909C166.845 212.539 151.027 225.843 150.365 226.372L150.167 226.504L122.104 226.769Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M152.814 175.21L170.089 181.233C170.486 179.313 170.817 177.262 171.148 175.21L154.601 169.65C154.006 171.636 153.41 173.489 152.814 175.21Z",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M124.556 189.373L107.149 165.216C103.774 159.392 98.1481 155.354 89.0146 153.832C78.0279 152.045 60.6214 151.979 51.885 154.494C40.3026 157.803 32.7576 167.731 33.6842 178.519L34.2798 231.599H108.473C107.745 223.194 105.627 217.369 108.01 202.345C112.643 196.587 120.783 190.168 124.556 189.373Z",
    fill: "#F6EFE8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_129_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M109.2 232.26H33.6835L33.0217 178.584C32.0289 167.531 39.7063 157.405 51.6196 153.963C60.6207 151.382 78.2258 151.514 89.0139 153.301C97.8165 154.758 103.839 158.53 107.546 164.884L111.848 170.84C112.046 171.105 111.98 171.502 111.715 171.701C111.451 171.899 111.053 171.833 110.855 171.568L106.553 165.546C103.045 159.523 97.2208 155.883 88.8816 154.493C78.2258 152.706 60.8854 152.573 52.0167 155.088C40.6329 158.332 33.3526 167.994 34.2792 178.518L34.8748 231.069H107.81C107.678 229.348 107.413 227.627 107.215 226.039C106.354 219.552 105.428 212.868 107.877 199.498L108.936 192.615C109.002 192.284 109.333 192.02 109.664 192.086C109.995 192.152 110.259 192.483 110.193 192.814L109.134 199.697C106.685 212.934 107.612 219.486 108.472 225.906C108.737 227.759 109.002 229.679 109.134 231.664L109.2 232.26Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_139_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M59.5645 152.705L63.8665 158.132C69.6907 165.478 81.4716 162.169 82.5967 152.903L80.545 130.996H63.0722L59.5645 152.705Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_70_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M72.0753 162.767C68.766 162.767 65.5892 161.244 63.4051 158.531L58.9707 152.905L62.6109 130.402H81.1426L83.2605 152.971V153.038C82.731 157.604 79.6203 161.178 75.186 162.436C74.127 162.634 73.0681 162.767 72.0753 162.767ZM60.2282 152.574L64.3317 157.803C66.8467 160.98 70.884 162.303 74.7889 161.244C78.6938 160.119 81.4073 157.009 81.9368 152.971L79.9513 131.66H63.6036L60.2282 152.574Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M173.067 158.927C172.405 158.464 171.545 158.133 170.685 158.133C169.89 158.067 169.559 158.067 169.096 157.471C168.699 156.942 168.037 156.545 167.309 156.677C167.044 156.743 166.383 157.074 166.184 157.008C166.118 157.008 166.118 156.942 166.118 156.942C165.588 156.148 164.993 155.287 163.868 155.486C163.404 155.552 163.073 155.817 162.809 156.214H162.742L163.735 148.338C163.867 147.345 164 146.286 164.198 145.293C164.331 144.234 164.529 143.175 164.463 142.116C164.463 141.521 164.397 140.925 164.066 140.462C163.735 139.999 163.139 139.601 162.61 139.734C161.948 139.866 161.551 140.594 161.352 141.256C160.294 144.764 159.896 148.338 159.102 151.912C158.109 156.479 157.05 161.045 155.793 165.546L171.743 170.907L174.656 163.626C175.251 162.104 174.589 160.317 173.398 159.258C173.266 159.126 173.2 158.994 173.067 158.927Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M155.798 166.074C155.732 166.074 155.665 166.074 155.665 166.074C155.335 166.007 155.136 165.676 155.202 165.345C156.526 160.382 157.651 155.484 158.511 151.711C158.776 150.388 159.041 149.064 159.306 147.74C159.703 145.556 160.1 143.24 160.762 140.989C161.093 139.931 161.688 139.203 162.482 139.07C163.277 138.938 164.137 139.335 164.6 140.063C164.997 140.725 165.064 141.453 165.13 142.048C165.196 143.174 164.997 144.233 164.865 145.292L164.402 148.336L163.409 156.212C163.343 156.543 163.078 156.808 162.747 156.741C162.416 156.675 162.152 156.411 162.218 156.08L163.21 148.204L163.674 145.159C163.806 144.166 163.939 143.107 163.939 142.115C163.939 141.519 163.806 141.056 163.608 140.725C163.409 140.394 163.078 140.195 162.813 140.261C162.35 140.328 162.085 141.056 162.019 141.32C161.357 143.505 160.96 145.755 160.563 147.939C160.298 149.263 160.1 150.586 159.769 151.976C158.908 155.749 157.783 160.713 156.46 165.676C156.327 165.941 156.063 166.074 155.798 166.074Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M171.749 171.503C171.682 171.503 171.616 171.503 171.55 171.436C171.219 171.304 171.087 170.973 171.219 170.642L174.131 163.362C174.595 162.171 174.197 160.648 173.072 159.656C173.006 159.589 172.874 159.523 172.808 159.391C172.212 158.994 171.484 158.729 170.756 158.663C170.425 158.663 170.16 158.332 170.16 158.001C170.16 157.67 170.491 157.405 170.822 157.405C171.749 157.471 172.741 157.802 173.536 158.332C173.668 158.398 173.8 158.53 173.933 158.663C175.389 159.986 175.984 162.038 175.323 163.693L172.41 170.973C172.212 171.37 172.013 171.503 171.749 171.503Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M174.859 151.317C174.793 150.721 174.065 150.324 173.469 150.258C172.145 150.126 170.954 150.854 169.829 151.582C166.387 153.832 162.946 156.082 159.504 158.332L164.666 167.731C165.858 167.003 166.652 165.811 167.049 164.421C167.446 163.032 167.38 161.642 166.983 160.318C166.917 160.119 166.85 159.921 166.85 159.656C166.85 159.193 167.181 158.862 167.512 158.597C169.829 156.744 172.278 154.825 174.263 152.641C174.594 152.31 174.925 151.846 174.859 151.317Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M41.8871 206.579L72.4645 231.663H55.3888H35.0039L41.8871 206.579Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M63.5359 192.35L71.4119 206.844C72.0076 208.035 73.2651 208.83 74.5888 208.962C88.5537 210.22 102.717 212.404 116.748 212.801L119.727 213.132L147.458 222.861C150.304 223.854 152.621 226.038 153.812 228.817L154.209 229.81C154.408 230.34 154.01 230.869 153.481 230.869L123.896 230.009L115.557 231.531C115.557 231.531 115.557 231.531 115.491 231.531H115.425C112.711 231.531 67.7055 231.531 67.7055 231.531C61.0209 231.531 56.2556 228.222 51.0932 222.133C51.0932 222.133 40.5036 209.028 42.0921 203.601C43.8129 197.843 57.6455 190.761 63.5359 192.35Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M114.762 232.392V232.26C108.541 232.26 67.7051 232.26 67.7051 232.26C61.3514 232.26 56.3875 229.48 50.6295 222.663L50.5633 222.597L37.9882 202.014C37.7896 201.749 37.922 201.352 38.1867 201.153C38.4515 200.955 38.8486 201.087 39.0471 201.352L51.6222 221.935C57.1156 228.421 61.8147 231.069 67.7051 231.069C67.7051 231.069 112.711 231.069 115.424 231.069L123.83 229.546L153.481 230.407C153.547 230.407 153.613 230.407 153.613 230.341C153.613 230.341 153.679 230.274 153.613 230.208L153.216 229.215C152.091 226.568 149.907 224.516 147.193 223.59L119.528 213.861L116.483 213.53C107.151 213.265 97.6206 212.206 88.4209 211.147C83.8542 210.618 79.0889 210.088 74.456 209.691C72.8675 209.559 71.5438 208.632 70.8158 207.242L63.0722 192.88C59.6968 192.152 53.2107 194.27 48.1144 197.844C47.8497 198.042 47.4526 197.976 47.254 197.712C47.0555 197.447 47.1217 197.05 47.3864 196.851C52.1517 193.542 59.4982 190.63 63.6679 191.755L63.9326 191.821L71.8748 206.58C72.4042 207.639 73.397 208.301 74.5883 208.367C79.2213 208.764 83.9866 209.294 88.6195 209.823C97.8192 210.882 107.416 211.941 116.748 212.206H117.41V212.272L119.991 212.537L147.722 222.266C150.767 223.325 153.216 225.641 154.473 228.62L154.87 229.613C155.069 230.076 155.003 230.539 154.738 230.936C154.473 231.333 154.01 231.532 153.547 231.532L124.028 230.672L116.219 232.061V232.128H115.623L114.762 232.392Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M139.981 228.089C141.106 228.222 142.231 228.288 143.224 228.751C144.018 229.148 144.813 229.744 145.144 230.604C145.21 230.737 145.276 230.803 145.408 230.737C145.541 230.737 145.607 230.538 145.541 230.472C145.144 229.545 144.349 228.817 143.489 228.354C142.364 227.825 141.172 227.692 139.915 227.626C139.716 227.626 139.716 228.089 139.981 228.089Z",
    fill: "#F9696A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M59.695 128.681C60.1583 131.064 58.6361 133.314 56.2534 133.778C53.8708 134.241 51.6205 132.719 51.1572 130.336C50.6939 127.953 52.2161 125.703 54.5988 125.24C56.9153 124.843 59.2317 126.365 59.695 128.681Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M55.3911 134.503C53.0747 134.503 50.9568 132.849 50.4935 130.466C49.964 127.753 51.751 125.171 54.3984 124.642C57.1119 124.112 59.6931 125.899 60.2226 128.547C60.7521 131.26 58.9651 133.842 56.3177 134.371C56.053 134.437 55.7221 134.503 55.3911 134.503ZM55.3911 125.833C55.1264 125.833 54.9278 125.833 54.6631 125.899C52.6776 126.297 51.3539 128.282 51.751 130.268C52.1481 132.253 54.1336 133.577 56.1192 133.18C58.1047 132.783 59.4284 130.797 59.0313 128.812C58.7004 127.025 57.1781 125.833 55.3911 125.833Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M84.0533 117.163C84.0533 117.163 95.1061 149.197 75.6478 149.858C56.1233 150.52 53.873 122.458 53.873 122.458C53.873 122.458 61.9476 96.1165 84.0533 117.163Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M74.9165 150.453C63.7974 150.453 58.3041 141.32 55.6567 133.51C55.5243 133.179 55.7229 132.848 56.0538 132.716C56.3847 132.583 56.7157 132.782 56.848 133.113C59.4292 140.658 64.724 149.527 75.6445 149.196C79.4832 149.063 82.3291 147.673 84.1161 145.026C90.0066 136.422 83.5867 117.493 83.5205 117.295C83.3881 116.964 83.5867 116.633 83.9176 116.5C84.2485 116.368 84.5794 116.567 84.7118 116.898C84.9765 117.692 91.3965 136.621 85.1751 145.688C83.1234 148.666 79.9465 150.255 75.7107 150.387C75.3797 150.453 75.1812 150.453 74.9165 150.453Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M58.8325 124.712C59.4282 126.83 59.8915 130.14 58.8987 131.927C58.4354 132.721 57.4427 133.184 56.6484 132.787C55.3909 132.059 55.06 130.206 54.5305 129.014C53.8687 127.625 52.9421 126.499 51.7508 125.44C49.4343 123.455 46.3898 121.999 45.8603 118.756C45.5294 116.836 46.5884 113.461 48.7725 113.064C49.1696 112.998 49.5667 112.998 49.8976 112.733C50.0962 112.534 50.1623 112.137 50.2285 111.873C50.8904 107.835 56.3837 103.666 59.5606 101.614C64.3921 98.5032 70.3487 96.5177 76.2391 97.5104C81.4015 98.3708 86.5639 102.21 88.2848 107.24C89.6746 111.211 88.6157 116.175 85.1741 118.623C80.5411 121.999 72.7313 120.807 67.966 118.226C67.1718 117.829 63.8626 115.645 63.5978 114.917C64.2597 116.77 64.3921 118.756 63.4655 120.543C62.6051 122.131 60.5533 123.72 58.7002 124.051C58.7002 124.117 58.7664 124.381 58.8325 124.712Z",
    fill: "#EF9E8F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M78.6197 124.113C78.4211 124.113 78.2226 124.047 78.0902 123.848C77.8916 123.583 77.9578 123.186 78.2888 122.988C78.4211 122.921 80.9361 121.267 83.7821 122.921C84.0468 123.12 84.1792 123.451 84.0468 123.782C83.8483 124.047 83.5174 124.179 83.1864 124.047C81.0023 122.789 79.083 124.047 79.0168 124.113C78.8844 124.113 78.7521 124.113 78.6197 124.113Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M82.128 127.291C82.3927 127.887 82.1942 128.615 81.7309 128.813C81.2014 129.078 80.6057 128.747 80.2748 128.152C80.0101 127.556 80.2086 126.828 80.6719 126.629C81.2014 126.365 81.7971 126.696 82.128 127.291Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M66.1856 127.753C66.0533 127.753 65.9209 127.753 65.8547 127.621C65.59 127.422 65.4576 127.025 65.6561 126.76C65.7223 126.628 67.3769 124.179 70.62 124.51C70.9509 124.576 71.2157 124.841 71.1495 125.172C71.0833 125.503 70.8186 125.768 70.4876 125.702C67.9726 125.437 66.7151 127.356 66.6489 127.422C66.5827 127.621 66.3842 127.753 66.1856 127.753Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M71.0147 129.478C71.2795 130.074 71.0809 130.802 70.6176 131C70.0881 131.265 69.4925 130.934 69.1615 130.339C68.8968 129.743 69.0954 129.015 69.5587 128.816C70.0881 128.552 70.75 128.816 71.0147 129.478Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M77.4333 137.351C77.1024 137.351 76.8376 137.086 76.8376 136.821C76.8376 136.49 77.0362 136.159 77.3671 136.159L79.2203 135.961L76.7714 130.004C76.6391 129.673 76.7714 129.342 77.1024 129.21C77.4333 129.078 77.7642 129.21 77.8966 129.541L80.4778 135.961C80.6101 136.225 80.544 136.49 80.4116 136.755C80.2792 137.02 80.0145 137.152 79.7497 137.218L77.4333 137.351C77.4995 137.351 77.4333 137.351 77.4333 137.351Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M76.1074 141.854C73.6586 141.854 72.9306 139.868 72.8644 139.802C72.732 139.471 72.9306 139.14 73.1953 139.008C73.5262 138.876 73.8572 139.074 73.9895 139.339C73.9895 139.405 74.519 140.596 76.0413 140.596H76.1074C76.4384 140.596 76.7031 140.861 76.7693 141.192C76.7693 141.523 76.5046 141.788 76.1736 141.854C76.2398 141.854 76.1736 141.854 76.1074 141.854Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_174_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M112.705 197.978C112.573 197.978 112.374 197.912 112.242 197.78C111.977 197.515 112.044 197.118 112.242 196.919C116.213 193.147 120.581 190.102 123.295 189.11L123.361 189.043C123.361 189.043 123.361 188.977 123.361 188.911L103.969 161.974C103.77 161.709 103.837 161.312 104.101 161.113C104.366 160.915 104.763 160.981 104.962 161.246L124.42 188.183C124.685 188.514 124.751 188.977 124.619 189.374C124.486 189.771 124.221 190.102 123.824 190.235C121.243 191.161 117.007 194.14 113.169 197.78C113.036 197.912 112.904 197.978 112.705 197.978Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M165.13 168.721C164.931 168.721 164.666 168.589 164.6 168.39C164.468 168.059 164.534 167.728 164.865 167.53C168.77 165.478 166.586 160.183 166.586 160.117L166.387 159.72L172.94 153.896C173.734 153.168 174.065 152.043 173.734 151.05L173.601 150.587C173.601 150.52 173.535 150.52 173.535 150.52C173.535 150.52 173.469 150.52 173.403 150.52L160.298 159.124C160.034 159.323 159.636 159.257 159.438 158.926C159.239 158.661 159.305 158.264 159.636 158.066L172.741 149.461C173.072 149.197 173.535 149.197 173.932 149.329C174.329 149.462 174.66 149.792 174.727 150.19L174.859 150.653C175.256 152.109 174.793 153.764 173.668 154.756L167.777 159.985C168.638 162.301 169.035 166.603 165.394 168.523C165.328 168.655 165.196 168.721 165.13 168.721Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M170.555 182.091L152.023 175.605L152.222 175.01C152.818 173.223 153.413 171.37 154.009 169.45L154.208 168.854L171.813 174.811L171.746 175.341C171.416 177.392 171.085 179.444 170.688 181.43L170.555 182.091ZM153.612 174.811L169.629 180.437C169.893 178.848 170.224 177.26 170.489 175.605L155.068 170.377C154.538 171.899 154.075 173.421 153.612 174.811Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M163.998 175.079C163.998 176.072 163.204 176.866 162.211 176.866C161.218 176.866 160.424 176.072 160.424 175.079C160.424 174.086 161.218 173.292 162.211 173.292C163.204 173.292 163.998 174.086 163.998 175.079Z",
    fill: "#FAAF3D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M134.349 206.98C134.217 206.98 134.018 206.914 133.886 206.782C133.621 206.517 133.621 206.12 133.886 205.921C135.408 204.399 135.144 202.215 135.144 202.215C135.077 201.884 135.342 201.553 135.673 201.553C136.004 201.487 136.335 201.752 136.335 202.083C136.335 202.215 136.666 204.862 134.746 206.848C134.614 206.914 134.482 206.98 134.349 206.98Z",
    fill: "#4A154B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M70.7465 213.528C70.5479 213.528 70.3494 213.461 70.217 213.263C70.0185 212.998 70.0846 212.601 70.3494 212.403C72.1364 211.079 72.0702 209.159 72.0702 209.027C72.0702 208.696 72.3349 208.365 72.6658 208.365C72.9968 208.365 73.3277 208.564 73.3277 208.961C73.3277 209.093 73.5262 211.674 71.1436 213.395C70.945 213.461 70.8127 213.528 70.7465 213.528Z",
    fill: "#4A154B"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSettingsPopupUser);
export default __webpack_public_path__ + "static/media/accountSettingsPopupUser.1a7b35486f8e7c0937e7bca85cfe84e4.svg";
export { ForwardRef as ReactComponent };